module.exports = function getResource(label) {
    const resources = {
        freeReturns: 'Free returns on all purchases*'
    };

    return resources[label];
};
